import React, { useEffect, useRef } from "react";
import { useDebouncedState } from "../../../../../../../../../utilities/hooks/useDebouncedState";
import { arraysEqual } from "../../../../../../../../../utilities/general";
import { useAppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import styles from "./styles.module.scss";

export const Choices = ({ blockId, value, onChange }) => {
  const { tSettings: t } = useAppTranslation.Settings({
    keyPrefix: "survey",
  });

  const inputRefs = useRef({});

  const [list, debouncedList, setList] = useDebouncedState(value);
  useEffect(() => {
    onChange(debouncedList);
  }, [debouncedList]);
  useEffect(() => {
    if (!arraysEqual(value, debouncedList)) {
      setList(value);
    }
  }, [value]);

  const handleKeyUp = (e) => {
    e.preventDefault();

    const index = Number(e.target.dataset.index);

    if (e.key === "Enter" && e.target.value.trim() !== "") {
      const newList = [...list];
      newList.splice(index + 1, 0, "");
      setList(newList);

      setTimeout(() => {
        const nextRef = inputRefs.current[index + 1];
        nextRef?.focus();
      }, 0);
    } else if (
      e.key === "Backspace" &&
      e.target.value === "" &&
      list.length > 1
    ) {
      const newList = [...list];
      newList.splice(index, 1);
      setList(newList);

      setTimeout(() => {
        const prevRef = inputRefs.current[index - 1];
        prevRef?.focus();
      }, 0);
    }
  };

  return (
    <div className={styles.root}>
      {list.map((item, index) => (
        <input
          key={`${blockId}-${index}`}
          data-index={index}
          ref={(el) => (inputRefs.current[index] = el)}
          placeholder={t("content.placeholder.choice")}
          className={styles.input}
          value={item}
          onKeyUp={handleKeyUp}
          onChange={(e) => {
            const newList = [...list];
            newList[index] = e.target.value;
            setList(newList);
          }}
        />
      ))}
    </div>
  );
};
